/**
 * Copyright © Veeam Software Group GmbH.
 */

/**
 * Copyright © Veeam Software Group GmbH.
 */

import type { PageWizardStore } from '..';

import { useWizardData } from '../../DialogWizard';

export const usePageWizardStore = <T,>(): PageWizardStore<T> => useWizardData<PageWizardStore<T>>();
